import React, { useState } from 'react';

const SearchFilter = ({ mode, handleSearchFilter }) => {
    const [filters, setFilters] = useState({
        position: '',
        experience: '',
        location: '',
        available: '',
        schedule: '',
    });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    return (
        <div>
            {(mode === 'SearchTalents' || mode === 'MyTalents') && (
                <div className="search-filter-dashboard">
                    <input type="text" name="position" placeholder="Position" value={filters.position} onChange={handleChange} />
                    <input type="text" name="experience" placeholder="Experience" value={filters.experience} onChange={handleChange} />
                    <input type="text" name="location" placeholder="Location" value={filters.location} onChange={handleChange} />
                    <input type="text" name="available" placeholder="Availability" value={filters.available} onChange={handleChange} />
                    <input type="text" name="schedule" placeholder="Schedule" value={filters.schedule} onChange={handleChange} />
                    <button onClick={() => handleSearchFilter(filters)} className="search-button">
                        Search
                    </button>
                </div>
            )}
        </div>
    );
};

export default SearchFilter;

